




























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
@Component
export default class Search extends Vue {
  @Prop() objectId!: any
  @Prop() tabsArr!: any[]
  @Prop() tabsActive!: any
  @Prop() statusArr!: string[];
  @Prop() statusActive!: number;
  @Prop() cardHead!: any[];
  @Prop() getAllList!: Function
  handleClickStatus(id: number, val: any) {
    this.$emit('on-handle-click-status', id, val)
  }
  /**
   * 搜索框表单
   */
  form = {
    name: ''
  }
  @Watch('form.name')
  handleName(val:string) {
    this.$emit('input', val)
  }
  /**
   * 创建计划
   */
  // 点击 card 头部创建
  handleHeadCreate(id: string | number) {
    const { tabsArr, tabsActive } = this
    this.$router.push({
      path: '/operate/create',
      query: {
        objectId: tabsArr[tabsActive].id,
        objectName: tabsArr[tabsActive].name,
        type: 'add'
      }
    })
  }
}
